module.exports = __webpack_public_path__ + "img/boy_white_futuristic_brown.93f41029.png";